import { appInitialized } from '@mit/aws-react'
import { useStoreActions } from 'Store'
import { Access, AccountController, LookupController, Sponsor } from 'Api/controller'
import { Permission } from 'Store/models/Global'
import { ActivePage } from 'Store/models/Account'

const accountController = new AccountController()
const lookupController = new LookupController()

interface UseAppInitializationReturn {
  initializeApp: () => any
}

export const useAppInitializer = (): UseAppInitializationReturn => {
  const { setPermissions } = useStoreActions(action => action.GlobalModel)
  const { setActivePage } = useStoreActions(action => action.AccountModel)
  const { setSponsorsList } = useStoreActions(action => action.LookupModel)
  const location = window.location

  const getAccess = async (permissions: Access[]): Promise<Permission> => {
    const permissionObj: Permission = {}
    for (let i = 0; i < permissions.length; i++) {
      Object.assign(permissionObj, { [`${permissions[i].permission}`]: permissions[i].enabled })
    }
    return permissionObj
  }

  const page = (): void => {
    if (location.pathname === '/') setActivePage(ActivePage.Accounts)
    if (location.pathname === '/accounts') setActivePage(ActivePage.Accounts)
  }

  const initializeApp = async (): Promise<void> => {
    // Simulate api call. Don't use timeout
    // You can access easy peasy state in this hook

    const permissionsPromise = accountController.getPermissions()
    const sponsorsPromise = lookupController.getSponsors()

    Promise.allSettled([permissionsPromise, sponsorsPromise])
      .then(async resp => {
        if (resp[1].status === 'fulfilled') {
          if (resp[1].value.length >= 1) {
            const sponsorsList = resp[1].value.map((sponsor: Sponsor) => {
              return {
                icon: '',
                text: `${sponsor.firstName} ${sponsor.lastName}`,
                mitId: sponsor.mitId,
                kerb: sponsor.kerberos,
                dlc: sponsor.dlc
              }
            })
            setSponsorsList(sponsorsList)
          }
        }

        if (resp[0].status === 'fulfilled') {
          const access: Access[] = resp[0].value
          setPermissions(access)
          const permissionsAccess: Permission = await getAccess(access)
          if (
            permissionsAccess.viewEmployeeList ||
            permissionsAccess.viewUndergrads ||
            permissionsAccess.viewGrads ||
            permissionsAccess.viewVisitors ||
            permissionsAccess.viewAffiliates
          ) {
            page()
            appInitialized({
              isLoading: false,
              hasAccess: true,
              hasError: false
            })
          } else {
            appInitialized({
              isLoading: false,
              hasAccess: false,
              hasError: false
            })
          }
        }
      })
      .catch(err => console.error(err))

    // setTimeout(() => {
    //   appInitialized({
    //     isLoading: false,
    //     hasAccess: true,
    //     hasError: false
    //   })
    // }, 3000)
  }

  return { initializeApp }
}
